// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://jvltandqrrpzgjenmnhg.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imp2bHRhbmRxcnJwemdqZW5tbmhnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTIyODAxNjIsImV4cCI6MjA2Nzg1NjE2Mn0.ILtRCN-JSLZ_Z4J_pzmsOrRPzYnfPAuO7aijLpxexdw";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});